import { useEffect } from "react";

export function useSettingsScrollLock(open: boolean) {
  useEffect(() => {
    if (!open) return;
    const root = document.documentElement;
    const body = document.body;
    const x = window.scrollX, y = window.scrollY;
    const previous = { position: body.style.position, top: body.style.top, left: body.style.left, width: body.style.width, overflow: body.style.overflow, overscroll: root.style.overscrollBehavior, behavior: root.style.scrollBehavior };
    root.setAttribute("data-settings-open", "true");
    root.style.overscrollBehavior = "none";
    body.style.position = "fixed";
    body.style.top = `-${y}px`;
    body.style.left = `-${x}px`;
    body.style.width = "100%";
    body.style.overflow = "hidden";
    let lastX = 0, lastY = 0;
    const start = (event: TouchEvent) => {
      if (event.touches.length !== 1) return;
      lastX = event.touches[0].clientX;
      lastY = event.touches[0].clientY;
    };
    const move = (event: TouchEvent) => {
      if (event.touches.length !== 1) return; // Preserve pinch zoom.
      const dx = event.touches[0].clientX - lastX;
      const dy = event.touches[0].clientY - lastY;
      lastX = event.touches[0].clientX;
      lastY = event.touches[0].clientY;
      if (!dy || Math.abs(dx) > Math.abs(dy)) return;
      const node = event.target instanceof Element ? event.target : null;
      // The fixed Settings dialog is its own scroll container. Never cancel
      // gestures that start inside it: on iOS, preventing even a tiny move can
      // also cancel the following click and make every control appear frozen.
      if (node?.closest(".auth-dialog")) return;
      if (event.cancelable) event.preventDefault();
    };
    document.addEventListener("touchstart", start, { passive: true, capture: true });
    document.addEventListener("touchmove", move, { passive: false, capture: true });
    return () => {
      document.removeEventListener("touchstart", start, true);
      document.removeEventListener("touchmove", move, true);
      root.removeAttribute("data-settings-open");
      root.style.overscrollBehavior = previous.overscroll;
      body.style.position = previous.position;
      body.style.top = previous.top;
      body.style.left = previous.left;
      body.style.width = previous.width;
      body.style.overflow = previous.overflow;
      root.style.scrollBehavior = "auto";
      window.scrollTo(x, y);
      root.style.scrollBehavior = previous.behavior;
    };
  }, [open]);
}
